
<Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
  <h1 class="text-h2 centered mt-32 mb-16">Let's find the sitters closest to you</h1>
  <p class="text-body centered mb-24">We have sitters in 95% of U.S. neighborhoods.</p>
  <form>
    <div class="mb-32">
      <TextField
        id="zipCode"
        v-model="zipCode"
        labelName="ZIP code"
        name="postal-code"
        type="text"
        maxlength="5"
        pattern="[0-9]*"
        class="mb-24"
        inputmode="numeric"
        aria-label="Five-digit zip code"
        :status="helperStatus"
        :limit-input-to-pattern="true"
        :helperText="helperText"
      />
    </div>
    <div class="flex flex-row-reverse">
      <RouteStepperNextButton
        :stepData="reviewSection"
        :draftData="jobPostDraft"
        :validate="validate"
        @errors="errors = $event"
      />
    </div>
  </form>
</Card>
